/* eslint-disable simple-import-sort/imports */
// Polyfill for secure random number generation (required before crypto-js)
import 'react-native-get-random-values';

import './styles/variables';

// Polyfill for Node.js globals required by axios and other npm packages
import { Buffer } from 'buffer';
import process from 'process';
import { enableScreens } from 'react-native-screens';

import { MODE } from './config';
import { LOG_TO_RELEASE } from './actions/logs';

global.Buffer = Buffer;
global.process = process;

const initLogging = () => {
    // logging
    // console.disableYellowBox = true;
    const log = console.log.bind(console);
    console.error = (MODE !== 'qa' && LOG_TO_RELEASE) || MODE === 'qa' ? (message, ...args) => log(`E/: ${message}`, ...args) : () => true;
    console.log = (MODE !== 'qa' && LOG_TO_RELEASE) || MODE === 'qa' ? (message, ...args) => log(`D/: ${message}`, ...args) : () => true;
};

initLogging();

// Before rendering any navigation stack
enableScreens(false);

// polyfill for RegExp.escape
if (!RegExp.escape) {
    RegExp.escape = (s) => String(s)
        .replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
}
